import React from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router";

import { withStyles } from "@material-ui/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import GetAppIcon from "@material-ui/icons/GetApp";
import BlockIcon from "@material-ui/icons/Block";
import DeviceHubIcon from "@material-ui/icons/DeviceHub";
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import TableCell from "@material-ui/core/TableCell";
/* import Tooltip from "@material-ui/core/Tooltip"; */
import Radio from "@material-ui/core/Radio";

import { SimpleMenu } from "../../components/material-ui/Menu";

import {
  MESSAGE_STATUS,
  DIALOG_USER_STATE,
  FILE_FORMATS,
}                                     from "../../../core/constants";
import {
  download,
  showDate,
  decodeMessage,
  showError,
  filterKeys,
  withTranslation,
  GlobalState,
  getProject,
  isGAI,
  isASR,
}                                     from "../../../core/utils";
import {
  getData,
  deleteData,
  putData,
}                                     from "../../../core/fetchService";
import {
  getSelectedDataSetId,
  fetchProjectDataSets,
  fetchDataSets,
  updateDataset,
  changeDataset,
}                                     from "../../../features/settings";
import { setMessageState }            from "../../../features/messageInfo";

import IconButton                     from "../../components/material-ui/IconButton";

import EnhancedTable, { viewLink }    from "../../components/projectTable";
import ConfirmDialog                  from "../../components/confirmDialog";

import {
  viewStatus,
  linkStyle,
  Runnable,
  Runnables,
}                                     from "../../components/taskStatus";

import Scrollable                     from '../../components/helpers/scrollable';

import EditDialog, {
  UploadVariant,
  defaultDCImportConfig,
  defaultSAImportConfig,
}                                     from './EditDatasetDialog'

const UPLOAD_TASK_NAMES = ['upload', 'import_from_dc', 'import_from_sa', 'import_from_test'];

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexWrap: "wrap",
    height: '100%',
    overflow: 'auto',
  },
  button: {
    marginRight: 10,
  },
});

function viewDatasetStatus(row, cell) {
  const s_obj = row.execution;
  return viewStatus(row, cell, {
    s_obj,
    percent: s_obj?.progress?.percent,
    in_progress: {      /* Note: statuses' names (below) must match to runnables' params */
      vectorize:        'Vectorizing',
      upload:           'Loading',
      import_from_dc:   'Loading',
      import_from_sa:   'Loading',
      import_from_test: 'Loading',
      generate:         'Generating',
    }[s_obj?.task_name],
  });
}

function viewStat(row, cell) {
  return row[cell._id] == 0 ? '' : row[cell._id];
}

function viewSize(row, cell) {
  return viewStat(row, cell);
  /*
  return row[cell._id] == 0 ? '-'
    : <Tooltip title={`manual: ${row.manual}, auto: ${row.auto}`}><div>{row[cell._id]}</div></Tooltip>;
    */
}

class Datasets extends React.Component{
  constructor(props) {
    super(props);
    const { projects, projectId } = props;

    this.state = this.getClearState_1();
    this.scrollable = new Scrollable(this);

    /* In fact, the actions (upload/import_from_dc/import_from_sa, vectorize and auto-annotate),
     * corresponding to these three runnables, are mutually exclusive. Still, it's simpler to use
     * three similar runnables, than to complicate the logic inside Runnable to support multiple
     * statusName values.
     */
    this.runnables = new Runnables({
      loadable: new Runnable({
        taskNames: UPLOAD_TASK_NAMES,
        getTaskName: ds => ds?.execution?.task_name,
        getStatus: ds => ds?.execution?.status,
        statusName: 'Loading',
        updateStatus: this.checkStatus,
        addActiveStatuses: ['Starting', 'Fetching', 'Parsing'],
      }),
      vectorizable: new Runnable({
        taskNames: ['vectorize'],
        getTaskName: ds => ds?.execution?.task_name,
        getStatus: ds => ds?.execution?.status,
        statusName: 'Vectorizing',
        updateStatus: this.checkStatus,
        addActiveStatuses: ['Preparing dataset'],
      }),
      annotatable: new Runnable({
        taskNames: ['annotate'],
        getTaskName: ds => ds?.execution?.task_name,
        getStatus: ds => ds?.execution?.status,
        statusName: 'Auto-annotating',
        updateStatus: this.checkStatus,
      }),
      generatable: new Runnable({
        taskNames: ['generate'],
        getTaskName: ds => ds?.execution?.task_name,
        getStatus: ds => ds?.execution?.status,
        statusName: 'Generating',
        updateStatus: this.checkStatus,
      }),
    });

    this.initMethodsForRunnables();
    this.globalState = new GlobalState(this.updateGlobalState);
  }

  isGenerative = () => {
    const { projects, projectId } = this.props;
    return isGAI(getProject(projects, projectId));
  };

  isASR = () => {
    const { projects, projectId } = this.props;
    return isASR(getProject(projects, projectId));
  };

  getClearState = () => ({
    editDialogOpen: false,
    dataSetName: null,
    description: "",
    similarityConfig: undefined,
    generationConfig: undefined,
    autoannotnConfig: undefined,
    formData: null,
    unique: false,
    isClone: false,
    dcImportConfig: defaultDCImportConfig,
    saImportConfig: defaultSAImportConfig,
    uploadProperties: {
      update_intents: false,
      check_audio: false,
    },
    tabValue: 0,
    header: false,
    role: "user",
    annStatus: "auto",
    radioValueFileType: this.isGenerative() ? "csv" : "json",
    intentSlotChecked: true,
    aniChecked: false,
    channelChecked: false,
    copyProps: {
      keep_intents: true,
      keep_entities: true,
    },
    copySlice: {
      start: '',
      end: '',
    },
    testId: undefined,
  });

  getClearState_1 = () => ({
    ...this.getClearState(),
    showModal: false,
    dialogTitle: undefined,
    uploadVariant: UploadVariant.File,  // TODO: replace with editMenuItemKey
    editMenuItemKey: 'item_from_llm',   // TODO: import menu descr from EditDatasetDialog
    modalContent: "",
    rowId: null,
    fileName: null,
    csvSeparator: "\\t",
    csvExtIdField: "3",
    csvInputField: "1",
    csvOutputField: "2",
    csvUtterance: this.isASR() ? "2" : "1",
    csvIntentField: this.isASR() ? "3" : "2",
    csvConfidence: this.isGenerative() ? "4" : "3",
    csvAudio: this.isASR() ? "1" : "4",
    showBtnNameAgree: true,
    showConfirmStatus: false,
  });

  getClearState_2 = () => ({ // TODO: same as 1
    ...this.getClearState(),
    absoluteDateChecked: false,
    relativeDateChecked: false,
  });

  initMethodsForRunnables = () => {
    this.isDatasetBeingProcessed = this.runnables.isObjActive;

    this.isStatusAnnotating =  this.runnables.annotatable.isRunning;
    this.isStatusVectorizing = this.runnables.vectorizable.isRunning;
    this.isStatusLoading =     this.runnables.loadable.isRunning;

    this.isAnnotationActive =  this.runnables.annotatable.isActive;
    this.isLoadActive =        this.runnables.loadable.isActive;

    this.isStatusRunning = this.runnables.isRunning;
    this.isActive =        this.runnables.isActive;
  };

  componentDidMount() {
    this.scrollable.componentDidMount();
    this.globalState.componentDidMount();
  }

  componentDidUpdate(prevProps) {
    this.runnables.componentDidUpdate(this.props.projectDatasets);
    this.globalState.componentDidUpdate(prevProps, this.props);
  }

  componentWillUnmount()  { this.runnables.componentWillUnmount() }

  checkStatus = (datasets, adjust) =>
    0 ? this.props.dispatch(fetchDataSets({ datasets, adjust })) // does not update order of datasets
    : Promise.all(datasets.length ? [this.props.dispatch(fetchProjectDataSets(this.props.projectId))] : []);

  adjustStatusTo = (status, ds, task_name) => ({ ...ds, execution: { ...ds.execution, task_name, status } });

  setStatusWaiting = (dataset, task_name) => {
    const { dispatch } = this.props;
    // this is to disable VECTORIZE/STOP icon in case a request is delayed/hanged up
    // with auto-update ON ('Waiting...' is in Runnable.isStatusActive)
    dispatch(updateDataset(this.adjustStatusTo('Waiting...', dataset, task_name)));
  }

  /*
  setStatusSaving = dataset => {
    const { dispatch } = this.props;
    // this is to disable VECTORIZE/STOP icon in case a request is delayed/hanged up
    // with auto-update OFF ('Saving...' is NOT in Runnable.isStatusActive)
    dispatch(updateDataset(this.adjustStatusTo('Saving...', dataset)));
  }
  */

  autoannotate = (id, stop=false) => {
    const { t, dispatch, projectDatasets } = this.props;
    const dataset = projectDatasets.find(ds => ds._id == id);
    this.setStatusWaiting(dataset, 'annotate');
    const [action, action_label] = stop
      ? (this.isStatusAnnotating(projectDatasets, id) ? ['stop_annotate', 'datasets.aatn_stopped']
         :                                               ['UNKNOWN', '_unk'])
      :                                                  ['annotate', 'datasets.autoannotating'];
    const msg_params = stop ? {} : { t, message_prefix: 'settings' };

    if (action == 'UNKNOWN')
      return showError(dispatch, t)('datasets.no_process', dataset);

    getData(`/api/dataset/${id}/${action}`, dispatch, data => {
      dispatch(setMessageState({
        snackBarMessages: t(action_label),
        snackBarVariant: stop ? MESSAGE_STATUS.INFO : MESSAGE_STATUS.SUCCESS,
        snackBarState: true,
      }));
      if (!stop)
        this.checkStatus([dataset]);
    }, { ...msg_params, on_error: () => this.checkStatus([dataset]) }).finally(() => {
      if (stop)
        this.checkStatus([dataset]);
    });
  };

  vectorize = (id, stop=false) => {
    const { t, dispatch, projectDatasets } = this.props;
    const dataset = projectDatasets.find(ds => ds._id == id);
    this.setStatusWaiting(dataset, 'vectorize');
    const [action, action_label] = stop
      ? (this.isStatusVectorizing(projectDatasets, id) ? ['stop_vectorize', 'datasets.vecn_stopped']
         : this.isStatusLoading(projectDatasets, id)   ? ['stop_upload', 'datasets.load_stopped']
         :                                               ['UNKNOWN', '_unk'])
      :                                                  ['vectorize', 'datasets.vectorizing'];
    const msg_params = stop ? {} : { t, message_prefix: 'settings' };

    if (action == 'UNKNOWN')
      return showError(dispatch, t)('datasets.no_process', dataset);

    getData(`/api/dataset/${id}/${action}`, dispatch, data => {
      dispatch(setMessageState({
        snackBarMessages: t(action_label),
        snackBarVariant: stop ? MESSAGE_STATUS.INFO : MESSAGE_STATUS.SUCCESS,
        snackBarState: true,
      }));
      if (!stop)
        this.checkStatus([dataset]);
    }, { ...msg_params, on_error: () => this.checkStatus([dataset]) }).finally(() => {
      if (stop)
        this.checkStatus([dataset]);
    });
  };

  handleVectorizeStopClick = (id, stop) => {
    const { t, projectDatasets: datasets } = this.props;
    const dataset = datasets.find(d => d._id == id);
    const name = dataset?.name;
    if (!stop)
      return this.setState({
        showModal: 'vectorize',
        rowId: id,
        dialogTitle: t('datasets.vecn_title', { name }),
        modalContent: t('datasets.vecn_question'),
      });
    const [stop_action_label, stop_question_label]
      = this.isStatusVectorizing(datasets, id) ? ['datasets.stop_vecn', 'datasets.stop_vecn_question']
      : this.isStatusLoading(datasets, id)   ? ['datasets.stop_upload', 'datasets.stop_upload_question']
      : ['???', '???'];
    this.setState({
      showModal: 'stop',
      rowId: id,
      dialogTitle: t(stop_action_label, { name: datasets.find(d => d._id == id)?.name }),
      modalContent: t(stop_question_label),
    });
  };

  handleAutoAnnotationStopClick = (id, stop) => {
    const { t, projectDatasets: datasets } = this.props;
    const dataset = datasets.find(d => d._id == id);
    const name = dataset?.name;
    if (!stop)
      return this.setState({
        showModal: 'autoannotate',
        rowId: id,
        dialogTitle: t('datasets.aatn_title', { name }),
        modalContent: t('datasets.aatn_question'),
      });
    const [stop_action_label, stop_question_label]
      = this.isStatusAnnotating(datasets, id) ? ['datasets.stop_aatn', 'datasets.stop_aatn_question']
      : ['???', '???'];
    this.setState({
      showModal: 'stop_aatn',
      rowId: id,
      dialogTitle: t(stop_action_label, { name: datasets.find(d => d._id == id)?.name }),
      modalContent: t(stop_question_label),
    });
  };

  fetchProjectDatasets = options =>
    this.props.dispatch(fetchProjectDataSets(this.props.projectId, options));

  updateGlobalState = () => {
    this.setState(this.getClearState_1());
    this.fetchProjectDatasets();
  };

  handleClickNewRow = (id, isClone) => {
    const { projectDatasets, projects, projectId, config } = this.props;
    const { composerConfig: projectComposerConfig } = projects.find(p => p._id == projectId);

    const dataset = projectDatasets?.find(ds => ds._id == id);
    const {
      name: dataSetName = null,
      description = "",
      dcImportConfig = null,
      saImportConfig = null,
      unique = true,
      similarityConfig,
      generationConfig,
      autoannotnConfig,
      testId,
    } = dataset || {};

    const hasImportConfig = Boolean(config.enableImportFromDC)
      && Boolean(projectDatasets.find(ds => ds._id == id)?.dcImportConfig);

    this.setState({
      tabValue: Number(hasImportConfig),
      uploadVariant: hasImportConfig ? UploadVariant.Composer : UploadVariant.File,
      dcImportConfig:  { ...(dcImportConfig || { ...this.state.dcImportConfig, ...projectComposerConfig }) },
      saImportConfig:  { ...(saImportConfig || this.state.saImportConfig) },
      intentSlotChecked: Boolean(dcImportConfig?.intent_slot),
      aniChecked: Boolean(dcImportConfig?.ani),
      channelChecked: Boolean(dcImportConfig?.channel),
      editDialogOpen: true,
      fileName: null,
      rowId: id,
      isClone,
      dataSetName,
      description,
      unique,
      similarityConfig,
      generationConfig,
      autoannotnConfig,
      testId,
    });
  };

  handleDownloadFile = (id, name, fileFormat) =>
    download(`/api/dataset/${id}/download?format=${fileFormat}`, this.props.dispatch);

  handleDeleteRow = (id, name) => {
    const { t } = this.props;
    this.setState({
      showModal: 'delete',
      rowId: id,
      dialogTitle: t("datasets.confirm_title"),
      modalContent: `Delete data set: ${name}?`,
    });
  };

  handleCloseDeleteModal = modalState => {
    const { selectedDataSetId, dispatch } = this.props;
    const { rowId, showModal: action } = this.state;
    this.setState({ showModal: false });
    if (rowId && modalState === DIALOG_USER_STATE.AGREE)
      if (['autoannotate', 'stop_aatn'].includes(action))
        this.autoannotate(rowId, action == 'stop_aatn');
      else if (['vectorize', 'stop'].includes(action))
        this.vectorize(rowId, action == 'stop');
      else if (action == 'delete')
        deleteData(`/api/dataset/${rowId}`, this.props.dispatch, data => {
          this.fetchProjectDatasets({ stat: false }).then(() => {
            if (rowId == selectedDataSetId)
              dispatch(changeDataset());
          });
        });
  };

  handleRowItemChanged = obj => {
    const { t, dispatch } = this.props;
    putData(`/api/dataset/${obj._id}`, {
      dataset: {
        [obj.rowName]: obj[obj.rowName],
        project: this.props.projectId,
      },
    }, dispatch, data => {
      this.checkStatus([{ _id: obj._id }]);
    }, {
      error_prefix: t('datasets.save_error'),
    });
  };

  handleExportMenuClose = (id, name) => fmt => {
    if (fmt)
      this.handleDownloadFile(id, name, fmt);
  };

  render() {
    const { classes, t, projects, projectId, projectDatasets, selectedDataSetId } = this.props;
    const {
      nluConfig: projectNLUConfig,
      similarityConfig: projectSimilarityConfig,
      generationConfig: projectGenerationConfig,
      autoannotnConfig: projectAutoannotnConfig,
    }
      = projects.find(p => p._id == projectId);

    const {
      showModal,
      dialogTitle,
      modalContent,
      showConfirmStatus,
      editDialogOpen,
      showBtnNameAgree,
      rowId,
      similarityConfig,
      generationConfig,
      autoannotnConfig,
    } = this.state;

    const getModalStatusContent = () => {
      const row = projectDatasets.find(d => d._id == rowId);
      if (!row) return null;
      const getErrorMessage = e => decodeMessage(e, this.props.t, 'datasets') || JSON.stringify(e);
      // TODO: common status dialog (see also ModelStatusDialog, modalContentStatus (tests and autoAnnotation))
      const show_error = s => s?.error ? (
        <tr style={{ color: "red" }}>
          <td>{t("common.error")}</td>
          <td>{getErrorMessage(s.error.error || s.error)}</td>
        </tr>
      ) : null;
      const show_progress = p => p ? (
        <>
          <tr><td>{t("progress.items")}</td><td>{p.current} {t("progress.items_of")} {p.total}</td></tr>
          <tr><td>{t("progress.percent")}</td><td>{p.percent}%</td></tr>
          <tr><td>{t("progress.time_elapsed")}, {t('common.seconds_a')}</td><td>{p.time_total}</td></tr>
          <tr><td>{t("progress.time_left")}, {t('common.seconds_a')}</td><td>{p.est_time_left}</td></tr>
        </>
      ) : null;
      const s = row.execution;
      const p = s?.progress;
      return <table style={{width: '100%'}}><tbody>
        {show_error(s)}
        {UPLOAD_TASK_NAMES.includes(s.task_name) ? (
          <>
            <tr>
              <td>{t("datasets.load_start")}</td>
              <td><span style={{ textDecoration: "underline" }}>{showDate(s?.started)}</span></td>
            </tr>
            {s.status == 'Loading...' ? show_progress(s?.progress) : null}
            <tr>
              <td>{t(s.status != "Aborted" ? "datasets.load_end" : "datasets.load_abort")}</td>
              <td><span style={{ textDecoration: "underline" }}>
                {!this.isDatasetBeingProcessed(row)? showDate(s.finished) : ''}
              </span></td>
            </tr>
          </>
        ) : s.task_name == 'annotate' ? (
          <>
            <tr>
              <td>{t("datasets.aatn_start")}</td>
              <td><span style={{ textDecoration: "underline" }}>{showDate(s.started)}</span></td>
            </tr>
            {s.status == 'Annotating...' && p && p.queued === undefined ? show_progress(p) : null}
            <tr>
              <td>{t(s.status != "Aborted" ? "datasets.aatn_end" : "datasets.aatn_abort")}</td>
              <td><span style={{ textDecoration: "underline" }}>
                {!this.isDatasetBeingProcessed(row) && p?.queued === undefined ? showDate(s.finished) : ''}
              </span></td>
            </tr>
          </>
        ) : s.task_name == 'vectorize' ? (
          <>
            <tr>
              <td>{t("datasets.vecn_start")}</td>
              <td><span style={{ textDecoration: "underline" }}>{showDate(s.started)}</span></td>
            </tr>
            {s.status == 'Vectorizing...' && p && p.queued === undefined ? show_progress(p) : null}
            <tr>
              <td>{t(s.status != "Aborted" ? "datasets.vecn_end" : "datasets.vecn_abort")}</td>
              <td><span style={{ textDecoration: "underline" }}>
                {!this.isDatasetBeingProcessed(row) && p?.queued === undefined ? showDate(s.finished) : ''}
              </span></td>
            </tr>
          </>
        ) : s.task_name == 'generate' ? (
          <>
            <tr>
              <td>{t("datasets.generate_start")}</td>
              <td><span style={{ textDecoration: "underline" }}>{showDate(s.started)}</span></td>
            </tr>
            {s.status == 'Generating...' && p && p.queued === undefined ? show_progress(p) : null}
            <tr>
              <td>{t(s.status != "Aborted" ? "datasets.generate_end" : "datasets.generate_abort")}</td>
              <td><span style={{ textDecoration: "underline" }}>
                {!this.isDatasetBeingProcessed(row) && p?.queued === undefined ? showDate(s.finished) : ''}
              </span></td>
            </tr>
          </>
        ) : (
          <tr><td>error: unknown_task!!</td></tr>
        )}
      </tbody></table>;
    }

    const headCells = [
      {
        _id: "name",
        label: t("common.name"),
        width: "auto",
        textSearch: true
      },
      {
        _id: "description",
        label: t("common.description"),
        width: "20%",
        textSearch: true,
        optional: true,
      },
      {
        _id: "size",
        label: t("datasets.num_rows_total"),
      },
      {
        _id: "manual",
        label: t("datasets.num_rows_manual"),
      },
      {
        _id: "auto",
        label: t("datasets.num_rows_auto"),
      },
      {
        _id: "updatedAt",
        label: t("common.date"),
        width: "20%",
        align: "left",
        dateTime: true,
      },
      {
        _id: "datasetStatus",
        label: t("common.status"),
        width: "15%",
        link: row => () => {
          this.setState({ showConfirmStatus: true, rowId: row._id });
        },
        style: linkStyle(row => [row.execution, this.isDatasetBeingProcessed(row)],
                         { Loaded: 'green', Vectorized: 'green', Generated: 'green', 'Auto-annotated': 'green' }),
      },
    ];

    const state = rowId ? this.state : {
      ...this.state,
      similarityConfig: {
        server: similarityConfig?.server ?? projectNLUConfig?.train_url,
        nlu_backend: similarityConfig?.nlu_backend ?? projectNLUConfig?.training,
        ...projectSimilarityConfig,
        ...similarityConfig,
      },
      generationConfig: {
        server: generationConfig?.server ?? projectNLUConfig?.train_url,
        nlu_backend: generationConfig?.nlu_backend ?? projectNLUConfig?.training,
        ...projectGenerationConfig,
        ...generationConfig,
      },
      autoannotnConfig: {
        server: autoannotnConfig?.server,
        nlu_backend: autoannotnConfig?.nlu_backend,
        ...projectAutoannotnConfig,
        ...autoannotnConfig,
      },
    };
    
    return (
      <div className={classes.root}>
        {showModal && (
          <ConfirmDialog
            maxWidth='sm'
            title={dialogTitle}
            open={true}
            showBtnNameAgree={showBtnNameAgree}
            content={modalContent}
            closeModal={this.handleCloseDeleteModal}
          />
        )}
        {showConfirmStatus && (
          <ConfirmDialog
            open={true}
            content={getModalStatusContent()}
            showBtnNameAgree={false}
            title={t("common.info")}
            btnNameDisagree={t("common.close")}
            closeModal={() => this.setState({ showConfirmStatus: false })}
          />
        )}
        {editDialogOpen && (
          <EditDialog
            {...{
              selectedDataSetId, state, setState: this.setState.bind(this),
              ...filterKeys(this, 'checkStatus setStatusWaiting adjustStatusTo'),
              ...filterKeys(this, 'fetchProjectDatasets getClearState_2')
            }}
          />
        )}
        {projectDatasets && (
          <EnhancedTable
            id="datasets"
            useLocationSearch
            headCells={headCells}
            rows={projectDatasets.map(ds => ds.execution ? { ...ds, datasetStatus: ds.execution?.status } : ds)
                .map(ds => { if (!ds.stat) return ds; const { updatedAt, ...ds_stat } = ds.stat; return { ...ds, ...ds_stat } })}
            viewCell={{ datasetStatus: viewDatasetStatus, size: viewSize, manual: viewStat, auto: viewStat }}
            toolBarName={t("datasets.datasets")}
            newRowTitle={t("datasets.new")}
            handleClickNewRow={() => this.handleClickNewRow(null, false)}
            handleClickCheckBox={() => this.handleClickCheckBox}
            handleClickUpdateRow={this.fetchProjectDatasets}
            handleRowItemChanged={this.handleRowItemChanged}
            checkBoxTableCell={id => <TableCellRadioButton id={id}/>}
            customBtns={(name, id) => {
              const is_aatn_active = this.isAnnotationActive(projectDatasets, id);
              const is_load_active = this.isLoadActive(projectDatasets, id);
              const is_active = this.isActive(projectDatasets, id);
              const is_active_vecn = is_active && !is_aatn_active;
              const is_active_annn = is_active && is_aatn_active;
              const is_status_running = this.isStatusRunning(projectDatasets, id);
              const is_status_running_aatn = is_status_running && is_aatn_active;
              const export_choices = Object.fromEntries(['JSON', 'CSV'].map(k => [FILE_FORMATS[k],k.toLowerCase()]));
              return (
                <div style={{width: "25%", display: "flex"}}>
                  <IconButton
                    className={classes.button}
                    title={t("common.edit")}
                    disabled={is_load_active}
                    onClick={() => this.handleClickNewRow(id, false)}
                    Icon={EditIcon}
                  />
                  <IconButton
                    className={classes.button}
                    title={t("common.clone")}
                    disabled={is_load_active}
                    onClick={() => this.handleClickNewRow(id, true)}
                    Icon={FileCopyIcon}
                  />
                  {this.isGenerative() || this.isASR() ? null :
                  <IconButton
                    className={classes.button}
                    title={t(is_active_vecn ? "common.stop" : "datasets.vectorize")}
                    style={is_active_vecn ? {} : {transform: 'rotate(180deg)'}}
                    disabled={is_active && !is_status_running || is_aatn_active}
                    onClick={() => this.handleVectorizeStopClick(id, is_active_vecn)}
                    Icon={is_active_vecn ? BlockIcon : DeviceHubIcon}
                  />}
                  {this.isASR() ? null :
                  <IconButton
                    title={t(is_active_annn ? "common.stop" : "datasets.annotate")}
                    variant="outlined"
                    className={classes.button}
                    disabled={is_active && !is_status_running || is_load_active}
                    onClick={() => this.handleAutoAnnotationStopClick(id, is_active_annn)}
                    Icon={is_active_annn ? BlockIcon : LocalOfferIcon}
                  />}
                  <SimpleMenu
                    title={t("common.export")}
                    choices={export_choices}
                    disabled={is_load_active}
                    handleClose={this.handleExportMenuClose(id, name)}
                    Icon={GetAppIcon}
                  />
                  <IconButton
                    title={t("common.delete")}
                    style={{marginLeft: 10}}
                    onClick={() => this.handleDeleteRow(id, name)}
                    Icon={DeleteIcon}
                  />
                </div>
              )
            }}
          />
        )}
      </div>
    );
  }
}

function TableCellRadioButton({ id }) {
  const selectedDataSetId = useSelector(getSelectedDataSetId);
  const dispatch = useDispatch();

  return (
    <TableCell padding="checkbox">
      <Radio
        checked={id == selectedDataSetId}
        onChange={() => dispatch(changeDataset(id))}
      />
    </TableCell>
  );
}

const mapStateToProps = (state) => ({
  config: state.settings.config,
  projects: state.settings.projects,
  projectId: state.settings.projectId,
  projectDatasets: state.settings.projectDatasets,
  selectedDataSetId: state.settings.selectedDataSetId,
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(withTranslation()(Datasets))),);
